import React, { PureComponent } from 'react';
import { Snackbar } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { setFlag } from 'controllers/flags';

import './snackbar.scss';

export class CommonSnackbar extends PureComponent {
  componentWillUnmount() {
    this.handleClose();
  }

  getMessage = () => {
    const { message, type } = this.props;

    if (type === 'success') {
      return (
        <span className="snackbar-success-message" id="message-id">
          <CheckCircleIcon />
          {message}
        </span>
      );
    }

    return <span id="message-id">{message}</span>;
  };

  handleClose = () => {
    const { flag, autoCloseSnackbar } = this.props;
    if (autoCloseSnackbar !== false) {
      setFlag(flag, false);
    }
  };

  render() {
    const { open, type } = this.props;

    return (
      <Snackbar
        className={`custom-snackbar snackbar-${type}`}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        variant="success"
        open={open}
        autoHideDuration={4000}
        onClose={this.handleClose}
        ContentProps={{
          'aria-describedby': 'message-id',
        }}
        message={this.getMessage()}
      />
    );
  }
}

CommonSnackbar.defaultProps = {
  classes: '',
  open: false,
  message: '',
  handleClose: () => {},
  type: 'default',
  flag: '',
};
